import { ActionsComp } from 'components';
import { Table, TableBody, TableCell, TableContainer } from 'components/mui';
import { TableHead, TablePagination, TableRow } from 'components/mui';
import { useContactExistList } from 'containers/pages/contacts/hooks';
import styles from './ContactExistList.module.css';
import { array, func } from 'prop-types';

/**
 * @component ContactExistList
 * @param {Object} props
 * @param {Contact[]} props.contacts
 * @param {function} props.onGetContactId
 * @param {function} props.onMode
 * @returns {JSX.Element}
 */
function ContactExistList({ contacts, onGetContactId, onMode }) {
	const state = useContactExistList(onGetContactId, onMode);

	return (
		<section className={styles.section}>
			<TableContainer className={styles.table_container}>
				<Table size="small">
					<TableHead>
						<TableRow>
							{state.tableHeadCells.map((cell) => (
								<TableCell key={cell.id}>{cell.label}</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{contacts
							.slice(
								state.page * state.rowsPerPage,
								state.page * state.rowsPerPage + state.rowsPerPage,
							)
							.map((contact) => {
								return (
									<TableRow key={contact.id} hover onClick={(e) => state.onRow(contact.id)}>
										<TableCell>{contact.firstName}</TableCell>
										<TableCell>{contact.lastName}</TableCell>
										<TableCell>{contact.phoneWork}</TableCell>
										<TableCell>{contact.phoneMobile}</TableCell>
										<TableCell>{contact.emailWork}</TableCell>
									</TableRow>
								);
							})}
					</TableBody>
				</Table>
				<TablePagination
					component="div"
					rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
					colSpan={3}
					count={contacts.length}
					rowsPerPage={state.rowsPerPage}
					page={state.page}
					onRowsPerPageChange={state.onRowsPerPage}
					onPageChange={state.onPage}
					ActionsComponent={ActionsComp}
				/>
			</TableContainer>
		</section>
	);
}

ContactExistList.propTypes = {
	contacts: array,
	onGetContactId: func,
	onMode: func,
};

export default ContactExistList;
